import type { CaseStudy } from '@/domain/content'

export const getCaseStudySlug = (c: CaseStudy): string => c.page.slug
